import {
  selectCloudAndCadAlignReference,
  selectModelClippingBoxEnabled,
} from "@/store/modes/cloud-cad-alignment-mode-selectors";
import {
  AlignmentReference,
  setModelClippingBoxEnabled,
} from "@/store/modes/cloud-cad-alignment-mode-slice";
import { useAppDispatch, useAppSelector } from "@/store/store-hooks";
import {
  ClippingBoxIcon,
  FaroTooltip,
  ToolButton,
  ToolGroup,
} from "@faro-lotv/flat-ui";
import { OverlayToolbar } from "@/components/ui/overlay-toolbar";
import type { JSX } from "react";
import { ModelElevationTool } from "./model-elevation-tool";

/** @returns The set-elevation step overlay for 3D model part */
export function ModelElevationOverlay(): JSX.Element {
  const dispatch = useAppDispatch();

  const isClippingBoxEnabled = useAppSelector(selectModelClippingBoxEnabled);

  const reference = useAppSelector(selectCloudAndCadAlignReference);

  return (
    <>
      <OverlayToolbar
        sx={{
          position: "absolute",
          right: reference === AlignmentReference.bimModel ? "0%" : "50%",
          top: "50%",
          transform: "translateY(-50%)",
          mr: 2,
        }}
      >
        <ToolGroup>
          <FaroTooltip title="Clip 3D model" placement="left">
            <ToolButton
              selected={isClippingBoxEnabled}
              onClick={() => {
                dispatch(setModelClippingBoxEnabled(!isClippingBoxEnabled));
              }}
            >
              <ClippingBoxIcon />
            </ToolButton>
          </FaroTooltip>
        </ToolGroup>
      </OverlayToolbar>
      <ModelElevationTool />
    </>
  );
}
